export default __webpack_public_path__ + "static/media/african_couple_haging_lovrican.d774b8a9.webp";